import { render, staticRenderFns } from "./DeptStyleRecord.vue?vue&type=template&id=77f361b3&scoped=true"
import script from "./DeptStyleRecord.vue?vue&type=script&lang=js"
export * from "./DeptStyleRecord.vue?vue&type=script&lang=js"
import style0 from "./DeptStyleRecord.vue?vue&type=style&index=0&id=77f361b3&prod&scoped=true&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f361b3",
  null
  
)

export default component.exports